// Data structure for this page is laid out here:
// https://github.com/aws-amplify/amplify-js/blob/master/packages/aws-amplify-react/src/Amplify-UI/Amplify-UI-Theme.jsx
import {
  SUCCESS,
  INFO,
  BACKGROUND_PRIMARY,
  QUARTER_CONTRAST,
  HALF_CONTRAST,
} from '../../theme';

export const theme = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100vw',
    alignItems: 'center',
    backgroundColor: BACKGROUND_PRIMARY,
  },
  // formContainer: FormContainer,
  formSection: {
    padding: 32,
    backgroundColor: 'white',
    marginTop: 24,
    borderRadius: 8,
  },
  formField: {
    paddingBottom: 8,
  },

  sectionHeader: {
    paddingBottom: 14,
    fontSize: 24,
  },
  // sectionBody: SectionBody,
  // sectionFooter: SectionFooter,
  // sectionFooterPrimaryContent: SectionFooterPrimaryContent,
  sectionFooterSecondaryContent: {
    paddingLeft: 12,
  },

  input: {
    width: '100%',
    padding: 12,
    fontSize: 18,
    marginTop: 6,
    marginBottom: 16,
    borderRadius: 3,
    borderWidth: 1,
    boxSizing: 'border-box',
    borderStyle: 'solid',
    borderColor: QUARTER_CONTRAST,
  },
  button: {
    backgroundColor: SUCCESS,
    border: 0,
    borderRadius: 3,
    color: 'white',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 12,
    fontSize: 18,
  },
  // photoPickerButton: PhotoPickerButton,
  // photoPlaceholder: PhotoPlaceholder,
  // signInButton: SignInButton,
  // signInButtonIcon: SignInButtonIcon,
  // signInButtonContent: SignInButtonContent,
  // amazonSignInButton: AmazonSignInButton,
  // facebookSignInButton: FacebookSignInButton,
  // googleSignInButton: GoogleSignInButton,
  // oAuthSignInButton: OAuthSignInButton,

  // formRow: FormRow,
  // strike: Strike,
  // strikeContent: StrikeContent,
  // actionRow: ActionRow,
  a: {
    cursor: 'pointer',
    color: INFO,
    display: 'inline-block',
    paddingLeft: 8,
  },

  hint: {
    paddingBottom: 12,
  },
  // radio: Radio,
  // label: Label,
  // inputLabel: InputLabel,
  // toast: Toast,

  // navBar: NavBar,
  // nav: Nav,
  // navRight: NavRight,
  // navItem: NavItem,
  // navButton: NavButton
};
